import { DatesAction, type DateState } from "@/types/dates";

export const datesReducer = (state: DateState, action: DatesAction) => {
  console.log("datesReducer", state, action);
  switch (action.type) {
    case "REPLACE_DATES": {
      return { ...state, dates: action.dates };
    }
    case "UPDATE_DATE_TYPE": {
      if (state.dateType === action.dateType) return state;

      return { ...state, dateType: action.dateType };
    }
    case "UPDATE_DATE_RANGES": {
      return { ...state, ranges: action.ranges };
    }
    case "REMOVE_DATE_RANGE": {
      // Remove the range from the list
      const newDates = [...state.dates];

      console.log("newDates before", newDates, action.ranges);

      const filteredDates = newDates.filter(
        (date) => !action.ranges.allValues?.includes(date),
      );

      console.log("newDates", filteredDates);

      return { ...state, dates: filteredDates };
    }
    default: {
      throw Error("Unknown action: " + action);
    }
  }
};
